import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  name: 'EquipmentControlLogList',
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/online/equipment/control/log',
      pageTitle: '设备仪表控制日志',
      userTree: [],
      //人员信息
      autoLoadInit: false,
      isorter: {
        column: 'log_date',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_id',
        title: '设备编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '控制人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'titleCode',
        colName: 'pol_id',
        title: '现场端控制编码',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'InfoIdDictTextInfoIdStr',
        colName: 'Info_id',
        title: '设备信息编码',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'info',
        colName: 'info',
        title: '控制参数',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'logDate',
        colName: 'log_date',
        title: '控制时间',
        align: 'center',
        sorter: true
      } // {
      //   dataIndex: 'msgContent',
      //   colName: 'msg_content',
      //   title: '报文内容',
      //   align: 'center',
      //   sorter: true
      // },
      // {
      //   title: '操作',
      //   dataIndex: 'action',
      //   align: 'center',
      //   width: 120,
      //   scopedSlots: { customRender: 'action' }
      // }
      ]
    };
  },
  props: {
    assetId: {
      type: Number,
      default: null
    }
  },
  created: function created() {
    this.queryParam.assetId = this.assetId;
    this.loadTreeList();
    this.loadData();
  },
  computed: {},
  methods: {
    searchReset: function searchReset() {
      this.queryParam = {
        assetId: this.assetId
      };
      this.dates = {};
      this.loadData(1);
    },
    onDateLogDate: function onDateLogDate(value, dateArray) {
      this.queryParam.logDateStart = dateArray[0];
      this.queryParam.logDateEnd = dateArray[1];
    },
    // 用户树下拉
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    initTableData: function initTableData(arg) {
      var _this2 = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.pagePath, params).then(function (res) {
        if (res.success) {
          res.result.records.forEach(function (e) {
            e.titleCode = e.title + '(' + e.code + ')';
            e.InfoIdDictTextInfoIdStr = e.InfoId_dictText + '(' + e.InfoIdStr + ')';
          });
          _this2.dataSource = res.result.records;
          _this2.ipagination.total = res.result.total;
        } else {
          _this2.$message.warning('系统异常=>' + res.message);
        }

        _this2.loading = false;
      });
    }
  }
};